import {useIsMobile} from "../../../../../hooks/useIsMobile";
import {InfoField} from "../InfoField/InfoField";
import styles from "./ContactField.module.scss";
import {ContactFieldProps} from "../../../../../types/props"


export const ContactField = ({name, nameMob, content, style } : ContactFieldProps) => {
    const isMobile = useIsMobile();

    return isMobile ? <div className={styles.contactField} style={style}>
                        <span className={styles.name}>{nameMob}</span>
                        <span className={styles.content}>{content}</span>
                      </div>
                    : <InfoField name={name} content={content} style={style} />
}